<template>
  <div
    class="poker-board pobrd"
    :class="{ pobrd_active: hasBoard }"
    :style="l_boards ? '--height:6.125em' : ''"
  >
    <CardRow
      :cards="l_board"
      :size="size"
      :class="[{ 'pr-1': boards }, cardRowClass]"
      :hasAnimation="hasAnimation"
      :cardClass="cardClass"
      :cardStyle="'--start-y: 0; --start-x: -32px'"
      :customAnimation="customAnimation"
      :hasSounds="hasSounds"
    />
    <div
      v-if="l_boards"
      class="pobrd_boards"
    >
      <CardRow
        v-for="(b, idx) in l_boards"
        :key="`board_${idx}`"
        :size="sizeBoards"
        :hasAnimation="hasAnimation"
        customAnimation="anim-deal-cards"
        :cards="b"
        :class="cardRowClass"
        :cardClass="cardClass"
        :hasSounds="hasSounds"
      />
    </div>
  </div>
</template>

<script>
import CardRow from '@/components/CardRow/CardRow'
import { getCardsFromStr } from '@/helpers/cards'

export default {
  name: 'PokerBoard',
  components: {
    CardRow,
  },
  props: {
    spot: Object,
    board: String,
    boards: Array,
    size: { default: () => 'large' },
    sizeBoards: { default: () => 'medium' },
    cardClass: String,
    cardRowClass: String,
    useNext: Boolean,
    animDelay: { default: 0 },
    customAnimation: { default: () => 'anim-deal-cards' },
    // customAnimation: { default: () => 'anim-card_enter' },
    hasSounds: Boolean,
    hasAnimation: { type: Boolean, default: true },
  },
  computed: {
    boardValues() {
      let res = {
        board:
          this.board ||
          this.boards?.[0] ||
          (this.useNext ? this.spot?.next_board || '' : this.spot?.board || ''),
        boards:
          this.boards?.length > 1
            ? this.boards
            : this.useNext
              ? this.spot?.next_boards || null
              : this.spot?.boards || null,
      }
      // console.log('boardValues', res, this.board, this.boards, this.spot)
      if (res.boards?.length > 1) {
        let sharedBoard = ''
        let boards = res?.boards.map(b => getCardsFromStr(b))
        boards[0].forEach((c, cIdx) => {
          if (boards[0][cIdx] === boards[1][cIdx]) {
            sharedBoard = `${sharedBoard}${c}`
            boards[0][cIdx] = ''
            boards[1][cIdx] = ''
          }
        })
        boards = boards.map(b => b.filter(c => c).join('')).filter(c => c)
        res = {
          board: sharedBoard,
          boards: boards.length > 1 ? boards : null,
        }
      }
      // console.log({
      //   res,
      //   board: this.board,
      //   boards: this.boards,
      //   useNext: this.useNext,
      //   spot: this.spot,
      // })
      // debugger
      return res
    },
    l_board() {
      return this.boardValues?.board || ''
    },
    l_boards() {
      return this.boardValues?.boards || null
    },
    hasBoard() {
      return !!(this.l_board || this.l_boards)
    },
  },
}
</script>

<style lang="scss" scoped>
.pobrd {
  display: flex;
  // align-items: center;
  justify-content: center;
  position: relative;
  height: 0;
  transition: 0.3s;
  --height: 4em;
  --boards-direction: column;
  --boards-gap: 2px;
  &_active {
    height: var(--height);
  }
  &_boards {
    display: flex;
    flex-direction: var(--boards-direction);
    gap: var(--boards-gap);
  }
}
</style>
